var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrymHealthLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.544,
    height: 35.938,
    viewBox: "0 0 92.544 35.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4665",
    "data-name": "Rectangle 4665",
    width: 92.544,
    height: 35.938,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28886",
    "data-name": "Group 28886",
    transform: "translate(-1614 -199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28885",
    "data-name": "Group 28885",
    transform: "translate(1614 199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28884",
    "data-name": "Group 28884",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140192",
    "data-name": "Path 140192",
    d: "M12.225,8.539a7.29,7.29,0,0,0-5.174-.945C4.775,7.96,2.471,8.364.2,8.8L0,8.833l.041.22a2.165,2.165,0,0,0,2.5,1.72l.282-.05c1.626-.3,3.281-.586,4.917-.853a4.1,4.1,0,0,1,3.1.585,3.507,3.507,0,0,1,1.467,2.522,3.746,3.746,0,0,1-.736,2.9,3.85,3.85,0,0,1-.875.836,4.393,4.393,0,0,1-1.763.671c-.979.177-3.227.566-6.87,1.188l-.205.035.039.2,1.828,9.632.038.2.2-.038c.673-.128,1.352-.253,2.018-.374l.2-.036L4.792,20.507c1.4-.251,2.818-.493,4.22-.718a7.067,7.067,0,0,0,4.461-2.413,5.815,5.815,0,0,0,1.4-4.7,5.528,5.528,0,0,0-2.647-4.138",
    transform: "translate(0 -2.935)",
    fill: "#0c3c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140193",
    "data-name": "Path 140193",
    d: "M46.689,15.6a6.922,6.922,0,0,0,3.727-1.874,5.82,5.82,0,0,0,1.83-4.546,5.579,5.579,0,0,0-2.241-4.353,7.188,7.188,0,0,0-5.053-1.442c-2.295.151-4.62.335-6.912.551l-.2.019.018.2,0,.02a2.146,2.146,0,0,0,2.316,1.932l.284-.024c1.643-.14,3.313-.264,4.964-.37a4.042,4.042,0,0,1,3.025.887,3.575,3.575,0,0,1,1.222,2.641,3.876,3.876,0,0,1-3.757,4.1c-1.594.1-3.211.223-4.808.358-.685.058-1.4.122-2.128.19l-.2.019.95,10.128.2-.019c.674-.063,1.359-.124,2.037-.182l.2-.017-.66-7.789c.716-.06,1.439-.117,2.155-.171,2.156,2.406,4.282,4.88,6.322,7.358l.065.08.1-.005c.909-.044,1.832-.083,2.742-.116l.419-.015-.27-.321c-2.049-2.437-4.185-4.869-6.351-7.236",
    transform: "translate(-14.847 -1.32)",
    fill: "#0c3c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140194",
    "data-name": "Path 140194",
    d: "M90.608,3.025a3.139,3.139,0,0,0-2.59,1.093c-1.9,2.241-3.782,4.543-5.594,6.842-1.663-2.409-3.4-4.823-5.15-7.18a3.145,3.145,0,0,0-2.515-1.255h0q-.692,0-1.382,0l-.42,0,.261.329c2.715,3.423,5.36,6.95,7.864,10.483l-.255,9.428.2.005c.687.018,1.374.04,2.042.064l.2.007.34-9.43C86.329,10.05,89.182,6.7,92.1,3.455l.28-.312-.418-.029q-.674-.047-1.35-.09",
    transform: "translate(-28.626 -0.991)",
    fill: "#0c3c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140195",
    "data-name": "Path 140195",
    d: "M137.915,7.764a1.974,1.974,0,0,0-1.673.454c-3.291,2.867-6.531,5.851-9.633,8.869-2.066-3.782-4.272-7.574-6.557-11.275a2,2,0,0,0-1.474-.931l-.237-.026L116.163,24.9l.2.022c.769.084,1.541.172,2.3.261l.2.024,1.607-13.5c1.751,2.883,3.455,5.826,5.071,8.755l.049.089.1.015.842.126.1.015.072-.07c2.389-2.315,4.865-4.615,7.37-6.844l-2.389,13.326.2.036c.753.135,1.519.276,2.277.42l.2.038L138.125,7.8Z",
    transform: "translate(-45.581 -1.905)",
    fill: "#0c3c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140196",
    "data-name": "Path 140196",
    d: "M30.451,53.826V45.588H31.1v3.5h5.068v-3.5h.65v8.238h-.65V49.669H31.1v4.157Z",
    transform: "translate(-11.949 -17.888)",
    fill: "#a2b9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140197",
    "data-name": "Path 140197",
    d: "M49.359,53.826V45.588h5.155v.586H50.008v2.909h3.508v.586H50.008v3.57h4.657v.587Z",
    transform: "translate(-19.368 -17.888)",
    fill: "#a2b9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140198",
    "data-name": "Path 140198",
    d: "M70.743,53.745l-.811-1.96H65.6l-.812,1.96h-.674l3.533-8.363h.262l3.519,8.363Zm-2.97-7.2L65.85,51.2h3.832l-1.91-4.656",
    transform: "translate(-25.158 -17.807)",
    fill: "#a2b9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140199",
    "data-name": "Path 140199",
    d: "M83.371,53.826V45.588h.649v7.651h4.058v.587Z",
    transform: "translate(-32.714 -17.888)",
    fill: "#a2b9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140200",
    "data-name": "Path 140200",
    d: "M96.946,53.826V46.174H93.939v-.586h6.678v.586H97.6v7.652Z",
    transform: "translate(-36.86 -17.888)",
    fill: "#a2b9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140201",
    "data-name": "Path 140201",
    d: "M111.84,53.826V45.588h.649v3.5h5.068v-3.5h.65v8.238h-.65V49.669h-5.068v4.157Z",
    transform: "translate(-43.884 -17.888)",
    fill: "#a2b9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140202",
    "data-name": "Path 140202",
    d: "M142.692,3.105V.46H141.48V.095h2.835V.46H143.1V3.105Z",
    transform: "translate(-55.515 -0.037)",
    fill: "#0c3c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140203",
    "data-name": "Path 140203",
    d: "M150.12,0h.141V3.068h-.407V1.034l-1.1,1.494h-.146l-1.107-1.5V3.068h-.407V0h.146l1.436,1.989Z",
    transform: "translate(-57.716 0)",
    fill: "#0c3c4c"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrymHealthLogo);
export default __webpack_public_path__ + "static/media/prym-health-logo.4e86ae514ca40f13e644749763aa49f5.svg";
export { ForwardRef as ReactComponent };